import { useCallback } from "react";
import {
  ONBOARDING_SPORTS,
  collectDirectionNames,
} from "../../../constants/onboardingSports";
import s from "../clinic.module.css";
import { Button, Field, Input } from "../../ui";

export default function DirectionStepForm({
  selection,
  onChange,
  onSubmit,
  saving,
  submitLabel = "Продолжить",
}) {
  const names = collectDirectionNames(selection);
  const canContinue = names.length > 0;

  const togglePreset = useCallback(
    (name) => {
      const has = selection.presets.includes(name);
      const presets = has
        ? selection.presets.filter((p) => p !== name)
        : [...selection.presets, name];
      const customs = has
        ? selection.customs.filter((c) => c !== name)
        : selection.customs;
      onChange({ ...selection, presets, customs });
    },
    [selection, onChange],
  );

  const addCustom = useCallback(() => {
    const name = selection.customDraft.trim();
    if (!name) return;
    const key = name.toLowerCase();
    if (
      selection.presets.some((p) => p.toLowerCase() === key) ||
      selection.customs.some((c) => c.toLowerCase() === key)
    ) {
      onChange({ ...selection, customDraft: "" });
      return;
    }
    onChange({
      ...selection,
      customs: [...selection.customs, name],
      customDraft: "",
    });
  }, [selection, onChange]);

  const removeCustom = useCallback(
    (name) => {
      onChange({
        ...selection,
        customs: selection.customs.filter((c) => c !== name),
      });
    },
    [selection, onChange],
  );

  const handleCustomKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addCustom();
    }
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (canContinue) onSubmit(e);
      }}
      className={[s.onboardingForm, s.onboardingDirectionForm].join(" ")}
    >
      <p className={s.onboardingDirectionHint}>
        Нажмите плитку ещё раз, чтобы снять выбор.
      </p>

      <div className={s.onboardingDirectionGrid}>
        {ONBOARDING_SPORTS.map((sport) => {
          const selected = selection.presets.includes(sport.name);
          return (
            <button
              key={sport.id}
              type="button"
              className={[
                s.onboardingSportTile,
                selected ? s.onboardingSportTileSelected : "",
              ]
                .filter(Boolean)
                .join(" ")}
              onClick={() => togglePreset(sport.name)}
            >
              {selected ? (
                <span className={s.onboardingSportTileCheck} aria-hidden />
              ) : null}
              <span className={s.onboardingSportTileIcon} aria-hidden>
                {sport.icon}
              </span>
              <span className={s.onboardingSportTileLabel}>{sport.label}</span>
            </button>
          );
        })}
      </div>

      <div className={s.onboardingDirectionOr} aria-hidden>
        <span>и свои</span>
      </div>

      <div className={s.onboardingDirectionCustomRow}>
        <Field label="Добавить своё" className={s.onboardingDirectionCustomField}>
          <div className={s.onboardingDirectionCustomInputRow}>
            <Input
              value={selection.customDraft}
              onChange={(e) =>
                onChange({ ...selection, customDraft: e.target.value })
              }
              onKeyDown={handleCustomKeyDown}
              placeholder="Например: Плавание"
            />
            <Button
              type="button"
              variant="secondary"
              size="sm"
              onClick={addCustom}
              disabled={!selection.customDraft.trim()}
            >
              +
            </Button>
          </div>
        </Field>
      </div>

      {selection.customs.length > 0 ? (
        <ul className={s.onboardingDirectionTags}>
          {selection.customs.map((name) => (
            <li key={name}>
              <span className={s.onboardingDirectionTag}>
                {name}
                <button
                  type="button"
                  className={s.onboardingDirectionTagRemove}
                  onClick={() => removeCustom(name)}
                  aria-label={`Убрать ${name}`}
                >
                  ×
                </button>
              </span>
            </li>
          ))}
        </ul>
      ) : null}

      {names.length > 0 ? (
        <p className={s.onboardingDirectionCount}>
          Выбрано: {names.length}
        </p>
      ) : null}

      <div className={s.onboardingSheetFoot}>
        <Button
          type="submit"
          disabled={!canContinue || saving}
          className={s.onboardingSubmitBtn}
          block
        >
          {saving ? "Сохранение…" : submitLabel}
        </Button>
      </div>
    </form>
  );
}
